import {
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eventbrite/site-analytics';
import { IAnalyticsDimensionsProps } from './interfaces';
import { getAnalyticsCategory } from './utils';

export const trackGeneralAuthAction = ({
    action,
    label,
    analytics,
}: {
    action: string;
    label?: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    if (analytics) {
        trackEventFromState(analytics, {
            category: getAnalyticsCategory(analytics),
            action,
            label,
        });
    }
};

export const trackGeneralPageUnloadAuthAction = ({
    action,
    label,
    analytics,
}: {
    action: string;
    label?: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    if (analytics) {
        trackEventFromStateOnPageUnload(analytics, {
            category: getAnalyticsCategory(analytics),
            action,
            label,
        });
    }
};
